"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var HttpDriver = require("./protocolCli/srvDriverHttpClient");
var srvDrv = HttpDriver.me;
var Server = (function () {
    function Server() {
        var _this = this;
        this.pollingFrequencyInitial = 1 * 60 * 1000;
        this.pollingFrequency = -1;
        this.myNotifHandlers = [];
        this.masterHardCodedUrl = [
            "https://app.framelink.co:3000",
            "https://app.frametest.eu:3000",
        ];
        this.instanceProviderUrl = "";
        this.masterIdx = 0;
        this.myCurrentInstance = undefined;
        this.myLocalServiceInfo = {
            flAdminUrl: "",
            svcInfo: [],
        };
        this.myTrace = 0;
        this.ttxIdDone = [];
        this.ttxId = 0;
        this.sessId = 0;
        this.notify = function (msg) {
            var newNotifs = [];
            var dicoECNs = [];
            if (_this.myNotifHandlers.length === 0) {
                return;
            }
            if (_this.currentAppId === -1) {
                return;
            }
            if (_this.ttxIdDone.length > 500) {
                _this.ttxIdDone.splice(0, 100);
            }
            var msgArr = msg instanceof (Array) ? msg : [msg];
            msgArr.forEach(function (aNotif) {
                newNotifs = [];
                if (aNotif.dbName !== _this.appList.apps[_this.currentAppId].dbName) {
                    return;
                }
                if (aNotif.ttxId === undefined) {
                    aNotif.ttxId = -1;
                }
                if (aNotif.ttxId <= 0 && aNotif.type !== "dicoUpdate") {
                    console.error("Notif with ttxId: " + aNotif.ttxId + "\n   " + JSON.stringify(aNotif));
                }
                if (_this.ttxIdDone.indexOf(aNotif.ttxId) !== -1) {
                    if (aNotif.type !== "flClient") {
                        console.error("Notif received twice: " + aNotif.ttxId + "-" + aNotif.dbName + "-" + aNotif.type);
                    }
                    return;
                }
                var notifType = _this.getNotifType(aNotif);
                if (notifType === 1) {
                    aNotif.data.forEach(function (aData) {
                        var virtEcn = (aData.c2 === "E") ? aData.id : aData.c1;
                        if (dicoECNs.indexOf(virtEcn) === -1) {
                            dicoECNs.push(virtEcn);
                        }
                    });
                }
                _this.myNotifHandlers.forEach(function (aNotifHdl) {
                    try {
                        if ((notifType & aNotifHdl.type) === notifType) {
                            var tmpNotif = aNotifHdl.handler(aNotif);
                            if (tmpNotif instanceof Array) {
                                tmpNotif.forEach(function (aNewNot) {
                                    newNotifs.push(aNewNot);
                                });
                            }
                        }
                    }
                    catch (err) {
                        console.error("Notification error: " + err.stack || err);
                        console.error("   for notification: " + JSON.stringify(msg));
                    }
                });
                newNotifs.forEach(function (aNewNot) {
                    notifType = _this.getNotifType(aNewNot);
                    _this.myNotifHandlers.forEach(function (aNotifHdl) {
                        try {
                            if ((notifType & aNotifHdl.type) === notifType) {
                                var tmpNotif = aNotifHdl.handler(aNewNot);
                                if (tmpNotif.length > 0) {
                                    throw new Error("a newNotif cannot return new notif");
                                }
                            }
                        }
                        catch (err) {
                            console.error("Notification error: " + err.stack || err);
                            console.error("   for notification: " + JSON.stringify(msg));
                        }
                    });
                });
                if (aNotif.ttxId !== -1) {
                    _this.ttxIdDone.push(aNotif.ttxId);
                }
                if (aNotif.ttxId !== -1) {
                    _this.setTtxId(aNotif.ttxId);
                }
            });
            if (dicoECNs.length > 0) {
                var tmpNotif_1 = {
                    type: "dicoUpdate",
                    ttxId: _this.getTtxId(),
                    dbName: _this.appList.apps[_this.currentAppId].dbName,
                    eCNs: dicoECNs,
                };
                _this.myNotifHandlers.forEach(function (aNotifHdl) {
                    try {
                        if ((aNotifHdl.type & 32) === 32) {
                            aNotifHdl.handler(tmpNotif_1);
                        }
                    }
                    catch (err) {
                        console.error("Notification dicoUpdate: " + err.stack || err);
                    }
                });
            }
        };
        this.instancesList = [];
        console.error("Framelink protocol v5.09.09");
        this.instancesList = [];
        this.srvDriver = srvDrv;
        this.freeCxion(true);
        var tmpProvider = [];
        this.masterHardCodedUrl.forEach(function (aProvider) {
            tmpProvider.push(_this.srvDriver.ValidateServerName(aProvider, ""));
        });
        this.masterHardCodedUrl = tmpProvider;
    }
    Server.getInstance = function () {
        if (!Server.myInstance) {
            Server.myInstance = new Server();
        }
        return Server.myInstance;
    };
    Server.prototype.isInstanceLoaded = function (instanceName) {
        return this.instancesList.find(function (i) { return i.instanceName === instanceName; }) !== undefined;
    };
    Server.prototype.getInstanceProviderUrl = function () {
        return this.instanceProviderUrl;
    };
    Server.prototype.getAvailableInstances = function (hostName, instProvider, bDisplayErrors) {
        if (instProvider === void 0) { instProvider = ""; }
        if (bDisplayErrors === void 0) { bDisplayErrors = true; }
        return __awaiter(this, void 0, void 0, function () {
            var myResp, masterUrls, tmpListProviders, tmpProtoHttps, loadInstRequest, tmpInstancesList, retM200, err_1, retM200, err_2, myPromises, m200SecondTry, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (hostName === undefined) {
                            throw new Error("a hostName is missing");
                        }
                        myResp = [];
                        masterUrls = [];
                        if (this.instancesList.length > 0 && this.currentHostName === hostName) {
                            this.instancesList.forEach(function (anInstance) { return myResp.push(anInstance.instanceName); });
                            return [2, myResp];
                        }
                        tmpListProviders = [];
                        tmpProtoHttps = (hostName.indexOf("localhost") > -1 ||
                            hostName.indexOf("127.0.0.1") > -1 ||
                            hostName.indexOf("host.docker.internal") > -1) ? false : true;
                        loadInstRequest = {
                            api: 3,
                            data: {},
                            dbName: "flmain",
                            eCN: 200,
                            id: -1,
                            params: {},
                            strOptions: "p=c201, c202",
                            sync: this.getTtxId(),
                            trace: this.getTrace(),
                            version: 3,
                        };
                        tmpInstancesList = [];
                        if (!(instProvider.length > 3)) return [3, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        masterUrls = [];
                        masterUrls.push(instProvider);
                        return [4, this.httpPostLowLevel(masterUrls[0], "", loadInstRequest)];
                    case 2:
                        retM200 = _a.sent();
                        this.instanceProviderUrl = masterUrls[0];
                        retM200.forEach(function (aM200) {
                            tmpInstancesList.push({
                                instanceName: aM200.c201,
                                hostName: aM200.c202,
                            });
                        });
                        this.currentHostName = hostName;
                        myResp = this.filterInstanceListAndGetInstanceNames(tmpInstancesList);
                        return [2, myResp];
                    case 3:
                        err_1 = _a.sent();
                        return [3, 4];
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        masterUrls = [];
                        masterUrls.push("http" + (tmpProtoHttps ? "s" : "") + "://" + hostName.split(":")[0] + ":3000/api2/");
                        return [4, this.httpPostLowLevel(masterUrls[0], "", loadInstRequest)];
                    case 5:
                        retM200 = _a.sent();
                        this.instanceProviderUrl = masterUrls[0];
                        retM200.forEach(function (aM200) {
                            tmpInstancesList.push({
                                instanceName: aM200.c201,
                                hostName: aM200.c202,
                            });
                        });
                        this.currentHostName = hostName;
                        myResp = this.filterInstanceListAndGetInstanceNames(tmpInstancesList);
                        return [2, myResp];
                    case 6:
                        err_2 = _a.sent();
                        return [3, 7];
                    case 7:
                        _a.trys.push([7, 9, , 10]);
                        masterUrls[0] = "http" + (tmpProtoHttps ? "" : "s") + "://" + hostName.split(":")[0] + ":3000/api2/";
                        myPromises = [];
                        myPromises.push(this.httpPostLowLevel(masterUrls[0], "", loadInstRequest, false));
                        tmpListProviders = [];
                        myPromises.push(this.waitAndRun(this.httpPostLowLevel(this.masterHardCodedUrl[tmpProtoHttps ? 0 : 1] + "/api2/", "", loadInstRequest, false)));
                        masterUrls.push(this.masterHardCodedUrl[tmpProtoHttps ? 0 : 1] + "/api2/");
                        return [4, this.firstPromiseResolve(myPromises)];
                    case 8:
                        m200SecondTry = _a.sent();
                        if (this.masterIdx === -1) {
                            throw new Error("internal error, masterIdx not loaded");
                        }
                        this.instanceProviderUrl = masterUrls[this.masterIdx];
                        m200SecondTry.forEach(function (aM200) {
                            tmpInstancesList.push({
                                instanceName: aM200.c201,
                                hostName: aM200.c202,
                            });
                        });
                        this.currentHostName = hostName;
                        myResp = this.filterInstanceListAndGetInstanceNames(tmpInstancesList);
                        return [2, myResp];
                    case 9:
                        err_3 = _a.sent();
                        this.instanceProviderUrl = "";
                        this.instancesList = [];
                        if (bDisplayErrors) {
                            console.error(err_3.stack || err_3);
                        }
                        err_3 = err_3.stack === undefined ? new Error(err_3) : err_3;
                        throw err_3;
                    case 10: return [2];
                }
            });
        });
    };
    Server.prototype.login = function (dataLogin) {
        return __awaiter(this, void 0, void 0, function () {
            var instanceName, _a, loginResp, _b, _c, anApp, err_4, err_5;
            var e_1, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.freeCxion();
                        instanceName = dataLogin.instanceName;
                        if (dataLogin.noDisplayError === undefined) {
                            dataLogin.noDisplayError = false;
                        }
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 8]);
                        this.freeCxion(true);
                        if (this.instancesList.length === 0) {
                            this.myCurrentInstance = undefined;
                            throw new Error("need to loadInstanceList first");
                        }
                        this.myCurrentInstance = this.instancesList.find(function (i) { return i.instanceName === instanceName; });
                        if (this.myCurrentInstance === undefined) {
                            throw new Error("Instance name not found");
                        }
                        _a = this;
                        return [4, this.httpFormatSecurePost(2, 1, "/api2/", -1, -1, dataLogin, "")];
                    case 2:
                        _a.appList = (_e.sent());
                        this.currentUI = this.appList.apps.length === 0 ? -1 : this.appList.apps[0].uid;
                        this.currentMasterId = this.appList.apps.length - 1;
                        loginResp = [];
                        try {
                            for (_b = __values(this.appList.apps), _c = _b.next(); !_c.done; _c = _b.next()) {
                                anApp = _c.value;
                                if (["flmain", "flmain_service"].indexOf(anApp.domain) === -1) {
                                    loginResp.push({
                                        description: anApp.description,
                                        domain: anApp.domain,
                                        isOwner: anApp.uid === anApp.ownerId,
                                        logo: anApp.logo,
                                    });
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2, loginResp];
                    case 3:
                        err_4 = _e.sent();
                        this.freeCxion(true);
                        if (!(dataLogin.domain !== "toto" && dataLogin.noDisplayError === false)) return [3, 7];
                        _e.label = 4;
                    case 4:
                        _e.trys.push([4, 6, , 7]);
                        return [4, this.login({ domain: "toto", instanceName: instanceName })];
                    case 5:
                        _e.sent();
                        return [3, 7];
                    case 6:
                        err_5 = _e.sent();
                        console.error("error during dummy login to a non existing domain-server.login");
                        return [3, 7];
                    case 7:
                        if (!dataLogin.noDisplayError) {
                            console.error(err_4);
                        }
                        err_4 = err_4.stack === undefined ? new Error(err_4) : err_4;
                        throw err_4;
                    case 8: return [2];
                }
            });
        });
    };
    Server.prototype.getNotifType = function (msg) {
        switch (msg.type) {
            case "data":
                if (msg.eCN === -1) {
                    return msg.data.length === 0 ? 2 : 1;
                }
                if (msg.eCN >= 500) {
                    return 2;
                }
                return 1;
            case "svc":
                return 4;
            case "dicoUpdate":
                return 8;
            case "flClient":
                return 128;
            case "paramUpdate":
                return 64;
        }
        console.error("unknown notif type received: " + JSON.stringify(msg));
        return 255;
    };
    Server.prototype.addNotificationHandler = function (name, notificationHandler, notifType) {
        var idx = this.myNotifHandlers.findIndex(function (h) { return h.name === name; });
        if (idx !== -1) {
            this.myNotifHandlers.splice(idx, 1);
        }
        if (typeof notificationHandler === "function") {
            this.myNotifHandlers.push({
                handler: notificationHandler,
                name: name,
                type: notifType,
            });
        }
    };
    Server.prototype.Use = function (domain, bNoErrorDisplay, bDicoOnly) {
        if (bNoErrorDisplay === void 0) { bNoErrorDisplay = false; }
        if (bDicoOnly === void 0) { bDicoOnly = undefined; }
        return __awaiter(this, void 0, void 0, function () {
            var data, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (this.myCurrentInstance === undefined) {
                            throw new Error("no active instance");
                        }
                        this.freeCxion();
                        this.loadCurrentAppId(domain);
                        if (!this.isUrlLoaded()) {
                            throw new Error("Domain " + domain + " does not exist");
                        }
                        return [4, this.httpFormatSecurePost(1, 19, "/api2", -1, -1, { domain: domain }, "", (bDicoOnly ? { dicoOnly: true } : {}))];
                    case 1:
                        data = _a.sent();
                        return [4, this.processUseResponse(data)];
                    case 2:
                        _a.sent();
                        return [2, {
                                accessLevel: this.appList.apps[this.currentAppId].userAccess,
                                dbName: this.appList.apps[this.currentAppId].dbName.toLowerCase(),
                                dicoData: data.dicos,
                                groupKeys: data.groupKeys,
                                jSonLogin: this.appList.apps[this.currentAppId].jSonLogin,
                                listFields: this.loginDataCurrentApp.listFields,
                                parameters: data.parameters,
                                serviceData: this.loginDataCurrentApp.services,
                                urlFilePrefix: data.urlFilePrefix,
                                userSetting: this.getUserSettings(),
                            }];
                    case 3:
                        err_6 = _a.sent();
                        this.freeCxion();
                        if (!bNoErrorDisplay) {
                            console.error(err_6.stack || err_6);
                        }
                        err_6 = err_6.stack === undefined ? new Error(err_6) : err_6;
                        throw err_6;
                    case 4: return [2];
                }
            });
        });
    };
    Server.prototype.closeDB = function (dbName) {
        return __awaiter(this, void 0, void 0, function () {
            var err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setPollingFreq(-1);
                        if (!this.isUrlLoaded()) {
                            this.freeCxion();
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        if (dbName !== this.appList.apps[this.currentAppId].dbName) {
                            throw new Error("dbName not opened");
                        }
                        if (!(this.myCurrentInstance !== undefined)) return [3, 3];
                        return [4, this.httpFormatSecurePost(1, 21, "/api2/", -1, -1, { database: this.getDBName() }, "", {})];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3, 6];
                    case 4:
                        err_7 = _a.sent();
                        return [3, 6];
                    case 5:
                        this.freeCxion();
                        return [7];
                    case 6: return [2];
                }
            });
        });
    };
    Server.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.freeCxion();
                return [2];
            });
        });
    };
    Server.prototype.getAllDocuments = function (eCN, options, appTarget) {
        if (options === void 0) { options = ""; }
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded() && appTarget === 1) {
            throw new Error("no active domain");
        }
        if (eCN === undefined || eCN === null) {
            throw new Error("no eCN");
        }
        return this.httpFormatSecurePost(appTarget, 33, "/api2", eCN, -1, {}, options, {});
    };
    Server.prototype.getOneDocument = function (eCN, id, options, appTarget) {
        if (options === void 0) { options = ""; }
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded() && appTarget === 1) {
            throw new Error("no active domain");
        }
        if (eCN === undefined || eCN === null || id === undefined || id === null || id === -1) {
            throw new Error("invalid parameter");
        }
        return this.httpFormatSecurePost(appTarget, 32, "/api2", eCN, id, {}, options, {});
    };
    Server.prototype.insertDocuments = function (eCN, newDocs, options, appTarget) {
        if (options === void 0) { options = ""; }
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded() && appTarget === 1) {
            throw new Error("no active domain");
        }
        if (eCN === undefined || eCN === null) {
            throw new Error("invalid parameter");
        }
        return this.httpFormatSecurePost(appTarget, 64, "/api2", eCN, -1, newDocs, options, {});
    };
    Server.prototype.replaceDocument = function (eCN, newDocs, options, appTarget) {
        if (options === void 0) { options = ""; }
        if (appTarget === void 0) { appTarget = 1; }
        if (newDocs.id === undefined) {
            throw new Error("invalid data, no id");
        }
        if (!this.isUrlLoaded() && appTarget === 1) {
            throw new Error("no active domain");
        }
        if (eCN === undefined || eCN === null || newDocs.id === undefined || newDocs.id === null || newDocs.id === -1) {
            throw new Error("invalid parameter");
        }
        return this.httpFormatSecurePost(appTarget, 36, "/api2", eCN, newDocs.id, newDocs, options, {});
    };
    Server.prototype.updateOneDocument = function (eCN, id, options, appTarget) {
        if (options === void 0) { options = ""; }
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded() && appTarget === 1) {
            throw new Error("no active domain");
        }
        if (eCN === undefined || eCN === null || id === undefined || id === null || id === -1) {
            throw new Error("invalid parameter");
        }
        return this.httpFormatSecurePost(appTarget, 37, "/api2", eCN, id, {}, options, {});
    };
    Server.prototype.updateMultipleDocuments = function (eCN, options, appTarget) {
        if (options === void 0) { options = ""; }
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("no active domain");
        }
        if (eCN === undefined || eCN === null) {
            throw new Error("invalid parameter");
        }
        return this.httpFormatSecurePost(appTarget, 38, "/api2", eCN, -1, {}, options, {});
    };
    Server.prototype.deleteOneDocument = function (eCN, id, options, appTarget) {
        if (options === void 0) { options = ""; }
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded() && appTarget === 1) {
            throw new Error("no active domain");
        }
        if (eCN === undefined || eCN === null || id === undefined || id === null || id === -1) {
            throw new Error("invalid parameter");
        }
        return this.httpFormatSecurePost(appTarget, 39, "/api2", eCN, id, {}, options, {});
    };
    Server.prototype.deleteMultipleDocuments = function (eCN, options, appTarget) {
        if (options === void 0) { options = ""; }
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded() && appTarget === 1) {
            throw new Error("no active domain");
        }
        if (eCN === undefined || eCN === null) {
            throw new Error("invalid parameter");
        }
        return this.httpFormatSecurePost(appTarget, 40, "/api2", eCN, -1, {}, options, {});
    };
    Server.prototype.getRollupData = function (rollupId, options, appTarget) {
        if (options === void 0) { options = ""; }
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("no active domain");
        }
        if (rollupId === undefined || rollupId === null || rollupId === -1) {
            throw new Error("invalid parameter");
        }
        return this.httpFormatSecurePost(appTarget, 65, "/api2/", -1, rollupId, {}, options, {});
    };
    Server.prototype.loadTemplateList = function (eCN, lfId, idToLimits) {
        if (idToLimits === void 0) { idToLimits = []; }
        if (!this.isUrlLoaded()) {
            throw new Error("no active domain");
        }
        return this.httpFormatSecurePost(1, 41, "/api2/", eCN, lfId, {}, "idToLimits=" + JSON.stringify(idToLimits), {});
    };
    Server.prototype.loadDBTemplate = function (templateContent, appTarget) {
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("no active domain");
        }
        return this.httpFormatSecurePost(appTarget, 34, "/api2/", -1, -1, templateContent, "", {});
    };
    Server.prototype.getDBTemplate = function (appTarget) {
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("no active domain");
        }
        return this.httpFormatSecurePost(appTarget, 35, "/api2/", -1, -1, {}, "", {});
    };
    Server.prototype.getNotifs = function (appTarget) {
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("no active domain");
        }
        return this.httpFormatSecurePost(appTarget, 50, "/api2/", -1, -1, {}, "", {});
    };
    Server.prototype.dePromoteToStr = function (eCN, lfId, options, appTarget) {
        if (options === void 0) { options = ""; }
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("no active domain");
        }
        if (eCN === undefined || eCN === null || lfId === undefined || lfId === null || lfId === -1) {
            throw new Error("invalid parameter");
        }
        return this.httpFormatSecurePost(appTarget, 31, "/api2", eCN, lfId, {}, options, {});
    };
    Server.prototype.promoteToFi = function (eCN, strId, options, appTarget) {
        if (options === void 0) { options = ""; }
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("no active domain");
        }
        if (eCN === undefined || eCN === null || strId === undefined || strId === null || strId === -1) {
            throw new Error("invalid parameter");
        }
        return this.httpFormatSecurePost(appTarget, 30, "/api2", eCN, strId, {}, options, {});
    };
    Server.prototype.getPgAccessInternals = function (appTarget) {
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("no active domain");
        }
        return this.httpFormatSecurePost(appTarget, 90, "/api2/", -1, -1, {}, -1, {});
    };
    Server.prototype.dump = function (bDisplay, appTarget) {
        if (bDisplay === void 0) { bDisplay = true; }
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("no active domain");
        }
        return this.httpFormatSecurePost(appTarget, 61, "/api2/", -1, -1, {}, -1, { bDisplay: bDisplay });
    };
    Server.prototype.dumpList = function (bDisplay, appTarget) {
        if (bDisplay === void 0) { bDisplay = true; }
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("database not opened");
        }
        if (!this.isUrlLoaded()) {
            throw new Error("no active domain");
        }
        return this.httpFormatSecurePost(appTarget, 63, "/api2/", -1, -1, {}, -1, { bDisplay: bDisplay });
    };
    Server.prototype.restore = function (dumpName, appTarget) {
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("database not opened");
        }
        return this.httpFormatSecurePost(appTarget, 62, "/api2/", -1, -1, {}, -1, { dumpName: dumpName });
    };
    Server.prototype.checkDB = function (dbName, appTarget) {
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("database not opened");
        }
        if (dbName === undefined || dbName === null) {
            throw new Error("invalid parameter");
        }
        return this.httpFormatSecurePost(appTarget, 60, "/api2/", -1, -1, {}, -1, { dbName: dbName });
    };
    Server.prototype.crashTest = function (param1, appTarget) {
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("database not opened");
        }
        return this.httpFormatSecurePost(appTarget, 91, "/api2/", -1, -1, {}, -1, { param1: param1 });
    };
    Server.prototype.mergeDocuments = function (task, appTarget) {
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("database not opened");
        }
        return this.httpFormatSecurePost(appTarget, 70, "/api2/", -1, -1, task, -1, {});
    };
    Server.prototype.callSvcExec = function (eCN, svcRequest, options, appTarget) {
        if (options === void 0) { options = ""; }
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded() && appTarget === 1) {
            throw new Error("no active domain");
        }
        if (eCN === undefined || eCN === null) {
            throw new Error("invalid parameter");
        }
        return this.httpFormatSecurePost(appTarget, 130, "/api2", eCN, -1, svcRequest, options, {});
    };
    Server.prototype.getParamShort = function (name, appTarget) {
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("database not opened");
        }
        return this.httpFormatSecurePost(appTarget, 124, "/api2/", -1, -1, { name: name }, -1, {});
    };
    Server.prototype.createParam = function (name, option, filter, appTarget) {
        if (option === void 0) { option = 0; }
        if (filter === void 0) { filter = {}; }
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("database not opened");
        }
        return this.httpFormatSecurePost(appTarget, 120, "/api2/", -1, -1, { name: name, option: option, filter: filter }, -1, {});
    };
    Server.prototype.deleteParam = function (name, appTarget) {
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("database not opened");
        }
        return this.httpFormatSecurePost(appTarget, 121, "/api2/", -1, -1, { name: name }, -1, {});
    };
    Server.prototype.updateParamOption = function (name, option, appTarget) {
        if (option === void 0) { option = 0; }
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("database not opened");
        }
        return this.httpFormatSecurePost(appTarget, 122, "/api2/", -1, -1, { name: name, option: option }, -1, {});
    };
    Server.prototype.updateParamValue = function (name, id, value, valueOnDemand, appTarget) {
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("database not opened");
        }
        var newData = { name: name, id: id, value: value };
        if (valueOnDemand !== undefined) {
            newData.valueOnDemand = valueOnDemand;
        }
        return this.httpFormatSecurePost(appTarget, 123, "/api2/", -1, -1, newData, -1, {});
    };
    Server.prototype.sendFile = function (fileName, buffer, appTarget) {
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("not logged");
        }
        if (this.myCurrentInstance === undefined) {
            throw new Error("instance not loaded - probably not logged in");
        }
        return this.srvDriver.PostFile(this.getServerUrl(4) + "/upload", this.getToken(1), this.getDBName(appTarget), fileName, buffer);
    };
    Server.prototype.sendFile_b64 = function (fileName, buffer, appTarget) {
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("not logged");
        }
        if (this.myCurrentInstance === undefined) {
            throw new Error("instance not loaded - probably not logged in");
        }
        return this.srvDriver.PostFile(this.getServerUrl(4) + "/upload_b64", this.getToken(1), this.getDBName(appTarget), fileName, buffer);
    };
    Server.prototype.getFile = function (fileName, appTarget) {
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("not logged");
        }
        return this.srvDriver.GetFile(this.getServerUrl(4) + "/download" +
            this.getOptionsUrl("dbName=" + this.getDBName(appTarget) + "&fileName=" + fileName), this.getToken(1));
    };
    Server.prototype.getFileUrl = function (fileName) {
        return this.getFilePrefixUrl() + "/" + this.getDBName(1) + "/" + fileName;
    };
    Server.prototype.getFilesList = function (appTarget) {
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("not logged");
        }
        if (this.myCurrentInstance === undefined) {
            throw new Error("instance not loaded - probably not logged in");
        }
        return this.srvDriver.GetFile(this.getServerUrl(4) + "/download" +
            this.getOptionsUrl("fileList=true&dbName=" + this.getDBName(appTarget)), this.getToken(1));
    };
    Server.prototype.deleteFile = function (fileName, appTarget) {
        if (appTarget === void 0) { appTarget = 1; }
        if (!this.isUrlLoaded()) {
            throw new Error("not logged");
        }
        return this.srvDriver.GetFile(this.getServerUrl(4) + "/download" +
            this.getOptionsUrl("fileDelete=true&dbName=" + this.getDBName(appTarget) + "&fileName=" + fileName), this.getToken(1));
    };
    Server.prototype.svcExec = function (svcName, api, groupKey, datawithQuote, nextRun, repeat, processInfo) {
        if (nextRun === void 0) { nextRun = new Date().getTime(); }
        if (repeat === void 0) { repeat = null; }
        if (processInfo === void 0) { processInfo = []; }
        return __awaiter(this, void 0, void 0, function () {
            var data, mySvcInfoSrv_1, config_1, jData, myRq, mySvcResp, errTry_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        data = JSON.parse(JSON.stringify(datawithQuote).replace(/'/g, "%27"));
                        if (!this.isUrlLoaded()) {
                            throw new Error("domain is closed. Please do a fl.Use");
                        }
                        if (this.myCurrentInstance === undefined) {
                            throw new Error("No instance loaded");
                        }
                        mySvcInfoSrv_1 = this.myLocalServiceInfo.svcInfo.find(function (s) { return s.name === svcName; });
                        if (mySvcInfoSrv_1 === undefined) {
                            throw new Error("service name not available: " + svcName);
                        }
                        if (repeat === null) {
                            repeat = undefined;
                        }
                        config_1 = mySvcInfoSrv_1.config;
                        this.appList.apps[this.currentAppId].serviceInfo.forEach(function (aSvcConfig) {
                            if (aSvcConfig.id === mySvcInfoSrv_1.svcId && aSvcConfig.config.length > 0) {
                                config_1 = aSvcConfig.config;
                            }
                        });
                        jData = {};
                        jData["c" + mySvcInfoSrv_1.fCNRequest] = {
                            api: api,
                            appId: this.appList.apps[this.getIdxInAppList(1)].appId,
                            instanceNo: 1,
                            config: config_1,
                            data: data,
                            date: new Date().toUTCString(),
                            dbName: this.appList.apps[this.getIdxInAppList(1)].dbName,
                            groupKey: groupKey,
                            histo: [],
                            instance: this.myCurrentInstance.instanceName,
                            nextRun: nextRun,
                            processInfo: processInfo,
                            repeat: repeat,
                            status: 1,
                        };
                        return [4, this.callSvcExec(mySvcInfoSrv_1.eCNRequest, { svcName: svcName, dbName: this.getDBName(), request: jData }, "", 3)];
                    case 1:
                        myRq = _a.sent();
                        if (myRq.length !== 1) {
                            throw new Error("not created !");
                        }
                        mySvcResp = myRq[0]["c" + mySvcInfoSrv_1.fCNRequest];
                        mySvcResp.id = myRq[0].id;
                        return [2, mySvcResp];
                    case 2:
                        errTry_1 = _a.sent();
                        console.error(errTry_1.stack);
                        throw errTry_1;
                    case 3: return [2];
                }
            });
        });
    };
    Server.prototype.svcGetAllRequests = function (svcName, options) {
        if (options === void 0) { options = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var mySvcInfoSrv, allRequests, myReq, allRequests_1, allRequests_1_1, aReq, errTry_2;
            var e_2, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        mySvcInfoSrv = this.myLocalServiceInfo.svcInfo.find(function (s) { return s.name === svcName; });
                        if (mySvcInfoSrv === undefined) {
                            throw new Error("service name not available: " + svcName);
                        }
                        return [4, this.getAllDocuments(mySvcInfoSrv.eCNRequest, options, 3)];
                    case 1:
                        allRequests = _b.sent();
                        myReq = [];
                        try {
                            for (allRequests_1 = __values(allRequests), allRequests_1_1 = allRequests_1.next(); !allRequests_1_1.done; allRequests_1_1 = allRequests_1.next()) {
                                aReq = allRequests_1_1.value;
                                aReq["c" + mySvcInfoSrv.fCNRequest].id = aReq.id;
                                aReq["c" + mySvcInfoSrv.fCNRequest].data = JSON.parse(JSON.stringify(aReq["c" + mySvcInfoSrv.fCNRequest].data).replace(/%27/g, "'"));
                                myReq.push(aReq["c" + mySvcInfoSrv.fCNRequest]);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (allRequests_1_1 && !allRequests_1_1.done && (_a = allRequests_1.return)) _a.call(allRequests_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        return [2, myReq];
                    case 2:
                        errTry_2 = _b.sent();
                        console.error(errTry_2.stack);
                        throw errTry_2;
                    case 3: return [2];
                }
            });
        });
    };
    Server.prototype.svcDeleteOneRequest = function (svcName, requestId) {
        return __awaiter(this, void 0, void 0, function () {
            var mySvcInfoSrv, allRequests, myReq, allRequests_2, allRequests_2_1, aReq, errTry_3;
            var e_3, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        mySvcInfoSrv = this.myLocalServiceInfo.svcInfo.find(function (s) { return s.name === svcName; });
                        if (mySvcInfoSrv === undefined) {
                            throw new Error("service name not available: " + svcName);
                        }
                        return [4, this.deleteOneDocument(mySvcInfoSrv.eCNRequest, requestId, "", 3)];
                    case 1:
                        allRequests = _b.sent();
                        myReq = [];
                        try {
                            for (allRequests_2 = __values(allRequests), allRequests_2_1 = allRequests_2.next(); !allRequests_2_1.done; allRequests_2_1 = allRequests_2.next()) {
                                aReq = allRequests_2_1.value;
                                aReq["c" + mySvcInfoSrv.fCNRequest].id = aReq.id;
                                myReq.push(aReq["c" + mySvcInfoSrv.fCNRequest]);
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (allRequests_2_1 && !allRequests_2_1.done && (_a = allRequests_2.return)) _a.call(allRequests_2);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        return [2, myReq];
                    case 2:
                        errTry_3 = _b.sent();
                        console.error(errTry_3.stack);
                        throw errTry_3;
                    case 3: return [2];
                }
            });
        });
    };
    Server.prototype.getSvcInfo = function (svcName) {
        try {
            var mySvcInfoSrv = this.myLocalServiceInfo.svcInfo.find(function (s) { return s.name === svcName; });
            return mySvcInfoSrv === undefined ? null : mySvcInfoSrv;
        }
        catch (errTry) {
            console.error(errTry.stack);
            throw errTry;
        }
    };
    Server.prototype.getSvcList = function () {
        var e_4, _a;
        var svcArr = new Array();
        try {
            for (var _b = __values(this.myLocalServiceInfo.svcInfo), _c = _b.next(); !_c.done; _c = _b.next()) {
                var aSvc = _c.value;
                svcArr.push({ id: aSvc.svcId, name: aSvc.name });
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return svcArr;
    };
    Server.prototype.getSvcConditions = function (svcName) {
        var mySvcDef = this.getSvcInfo(svcName);
        if (mySvcDef === null) {
            throw new Error("Service not available " + svcName);
        }
        return mySvcDef.conditionTables;
    };
    Server.prototype.getWHForAction = function (svcName, action) {
        try {
            if (!this.isUrlLoaded()) {
                throw new Error("no active domain");
            }
            var mySvcInfoSrv = this.myLocalServiceInfo.svcInfo.find(function (s) { return s.name === svcName; });
            if (mySvcInfoSrv === undefined) {
                throw new Error("service name not available: " + svcName);
            }
            return this.httpFormatSecurePost(3, 131, "/api2", mySvcInfoSrv.eCNWH, -1, { action: action, dbName: this.getDBName(), svcName: svcName }, {}, {});
        }
        catch (errTry) {
            console.error(errTry.stack);
            throw errTry;
        }
    };
    Server.prototype.getWHForRequest = function (svcName, requestId) {
        try {
            if (!this.isUrlLoaded()) {
                throw new Error("no active domain");
            }
            var mySvcInfoSrv = this.myLocalServiceInfo.svcInfo.find(function (s) { return s.name === svcName; });
            if (mySvcInfoSrv === undefined) {
                throw new Error("service name not available: " + svcName);
            }
            return this.httpFormatSecurePost(3, 132, "/api2", mySvcInfoSrv.eCNWH, -1, { requestId: requestId, dbName: this.getDBName(), svcName: svcName }, {}, {});
        }
        catch (errTry) {
            console.error(errTry.stack);
            throw errTry;
        }
    };
    Server.prototype.getWHFiltered = function (svcName, status, groupKey) {
        try {
            if (!this.isUrlLoaded()) {
                throw new Error("no active domain");
            }
            var mySvcInfoSrv = this.myLocalServiceInfo.svcInfo.find(function (s) { return s.name === svcName; });
            if (mySvcInfoSrv === undefined) {
                throw new Error("service name not available: " + svcName);
            }
            return this.httpFormatSecurePost(3, 134, "/api2", mySvcInfoSrv.eCNWH, -1, { status: status, groupKey: groupKey, dbName: this.getDBName(), svcName: svcName }, {}, {});
        }
        catch (errTry) {
            console.error(errTry.stack);
            throw errTry;
        }
    };
    Server.prototype.getWHInfos = function (svcName, ids) {
        return __awaiter(this, void 0, void 0, function () {
            var mySvcInfoSrv;
            return __generator(this, function (_a) {
                try {
                    if (!this.isUrlLoaded()) {
                        throw new Error("no active domain");
                    }
                    mySvcInfoSrv = this.myLocalServiceInfo.svcInfo.find(function (s) { return s.name === svcName; });
                    if (mySvcInfoSrv === undefined) {
                        throw new Error("service name not available: " + svcName);
                    }
                    return [2, this.httpFormatSecurePost(3, 136, "/api2", mySvcInfoSrv.eCNWH, -1, { ids: ids, dbName: this.getDBName(), svcName: svcName }, {}, {})];
                }
                catch (errTry) {
                    console.error(errTry.stack);
                    throw errTry;
                }
                return [2];
            });
        });
    };
    Server.prototype.deleteGroupKeys = function (svcName, groupKeyId) {
        return __awaiter(this, void 0, void 0, function () {
            var mySvcInfoSrv;
            return __generator(this, function (_a) {
                try {
                    if (!this.isUrlLoaded()) {
                        throw new Error("no active domain");
                    }
                    mySvcInfoSrv = this.myLocalServiceInfo.svcInfo.find(function (s) { return s.name === svcName; });
                    if (mySvcInfoSrv === undefined) {
                        throw new Error("service name not available: " + svcName);
                    }
                    return [2, this.httpFormatSecurePost(3, 135, "/api2", mySvcInfoSrv.eCNWH, -1, { groupKeyId: groupKeyId, dbName: this.getDBName(), svcName: svcName }, {}, {})];
                }
                catch (errTry) {
                    console.error(errTry.stack);
                    throw errTry;
                }
                return [2];
            });
        });
    };
    Server.prototype.getDBName = function (srvType) {
        if (srvType === void 0) { srvType = 1; }
        switch (srvType) {
            case 2:
                return "flmain";
            case 3:
                return "flmain_service";
            default:
                var tkIdx = this.getIdxInAppList(srvType);
                return this.appList.apps[tkIdx].dbName;
        }
    };
    Server.prototype.setTtxId = function (newTtxId) {
        if (newTtxId !== undefined && newTtxId > -1) {
            this.ttxId = newTtxId;
        }
    };
    Server.prototype.setPollingFreq = function (ms) {
        var _this = this;
        if (ms === void 0) { ms = -1; }
        if (this.polTimer !== null) {
            clearInterval(this.polTimer);
            this.polTimer = null;
        }
        if (ms === 0) {
            ms = this.pollingFrequency;
        }
        if (ms === -1) {
            return;
        }
        if (ms < 30000) {
            ms = 30000;
        }
        this.pollingFrequency = ms;
        this.polTimer = setInterval(function () { return _this.checkNotifs(); }, this.pollingFrequency);
    };
    Server.prototype.getTrace = function (trace) {
        if (trace === void 0) { trace = undefined; }
        if (trace !== undefined) {
            this.myTrace = trace;
        }
        return this.myTrace;
    };
    Server.prototype.getUserLogo = function () {
        if (!this.isUrlLoaded()) {
            return null;
        }
        return this.appList.userlogo;
    };
    Server.prototype.setUserLogo = function (newLogo) {
        this.appList.userlogo = newLogo;
    };
    Server.prototype.getCurrentApp = function () {
        if (!this.isUrlLoaded()) {
            return null;
        }
        return this.appList.apps[this.currentAppId].domain;
    };
    Server.prototype.IsAdmin = function () {
        if (!this.isUrlLoaded()) {
            throw new Error("Please use an application first");
        }
        if (this.IsFlAdmin()) {
            return true;
        }
        return ((this.appList.apps[this.currentAppId].userAccess & 255) ===
            255);
    };
    Server.prototype.IsFlAdmin = function () {
        if (!this.isUrlLoaded()) {
            throw new Error("Please use an application first");
        }
        return ((this.appList.apps[this.currentAppId].userAccess & 3583) ===
            3583);
    };
    Server.prototype.IsDesigner = function () {
        if (!this.isUrlLoaded()) {
            throw new Error("Please use an application first");
        }
        if (this.IsFlAdmin()) {
            return true;
        }
        return ((this.appList.apps[this.currentAppId].userAccess & 62) ===
            62);
    };
    Server.prototype.IsRestrictedUser = function () {
        if (!this.isUrlLoaded()) {
            throw new Error("Please use an application first");
        }
        return ((this.appList.apps[this.currentAppId].userAccess & 512) ===
            512);
    };
    Server.prototype.getUID = function () {
        if (!this.isUrlLoaded()) {
            return this.currentUI;
        }
        return this.appList.apps[this.currentAppId].uid;
    };
    Server.prototype.getUserName = function () {
        if (!this.isUrlLoaded()) {
            throw new Error("Please use an application first");
        }
        var myAppDef = this.appList.apps[this.currentAppId];
        if (myAppDef.uid === undefined || myAppDef.uid === null) {
            throw new Error("Error UID not initialized");
        }
        return myAppDef.userName || "??";
    };
    Server.prototype.getAccessLevel = function () {
        if (!this.isUrlLoaded()) {
            throw new Error("Please use an application first");
        }
        return this.appList.apps[this.currentAppId].userAccess;
    };
    Server.prototype.getOwnerId = function () {
        if (!this.isUrlLoaded()) {
            throw new Error("Please use an application first");
        }
        return this.appList.apps[this.currentAppId].ownerId;
    };
    Server.prototype.getOwnerName = function () {
        if (!this.isUrlLoaded()) {
            throw new Error("Please use an application first");
        }
        return this.appList.apps[this.currentAppId].ownerName;
    };
    Server.prototype.getWebhookDico = function () {
        if (!this.isUrlLoaded()) {
            throw new Error("Please use an application first");
        }
        return this.loginDataCurrentApp.webhooksDico;
    };
    Server.prototype.getCallUrl = function () {
        if (!this.isUrlLoaded()) {
            throw new Error("Please use an application first");
        }
        return this.appList.apps[this.currentAppId].callUrlList;
    };
    Server.prototype.getUserSettings = function () {
        if (!this.isUrlLoaded()) {
            throw new Error("Please use an application first");
        }
        return this.appList.apps[this.currentAppId].userSettings;
    };
    Server.prototype.getFileServerUrl = function () {
        if (this.myCurrentInstance === undefined) {
            throw new Error("please log on first");
        }
        return this.getServerUrl(4);
    };
    Server.prototype.getPublicApiUrl = function () {
        if (this.myCurrentInstance === undefined) {
            throw new Error("please log on first");
        }
        return this.appList.apps[this.currentAppId].publicFormUrl;
    };
    Server.prototype.getInstanceName = function () {
        if (this.myCurrentInstance === undefined) {
            throw new Error("please log on first");
        }
        return this.myCurrentInstance.instanceName;
    };
    Server.prototype.getTtxId = function () {
        return this.ttxId;
    };
    Server.prototype.isUrlLoaded = function (srvType) {
        if (srvType === void 0) { srvType = 1; }
        switch (srvType) {
            case 3:
                return this.currentAdminId !== -1;
            case 2:
                return true;
            case 1:
                return this.currentAppId !== -1;
            default:
                throw new Error("invalid srvType: " + srvType);
        }
    };
    Server.prototype.filterInstanceListAndGetInstanceNames = function (newIList) {
        var _this = this;
        var resp = [];
        this.instancesList = [];
        newIList.forEach(function (anInst) {
            if (_this.currentHostName.split(":")[0].indexOf(anInst.hostName) > -1 ||
                anInst.hostName.indexOf(_this.currentHostName.split(":")[0]) > -1) {
                resp.push(anInst.instanceName);
                _this.instancesList.push(anInst);
            }
        });
        return resp;
    };
    Server.prototype.checkNotifs = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    if (!this.isUrlLoaded()) {
                        return [2];
                    }
                    return [2, this.getNotifs()];
                }
                catch (err) {
                    console.error("error in checkNotifs: " + err.stack);
                }
                return [2];
            });
        });
    };
    Server.prototype.getOptionsUrl = function (options) {
        var myOpt = options;
        var supOptions = "ttxId=" + this.getTtxId() + "&Sid=" + this.sessId;
        if (options === null ||
            options === undefined ||
            options === "" ||
            options.length === 0) {
            myOpt = supOptions;
        }
        else {
            if (options.indexOf("ttxId=-1") > -1) {
                myOpt = myOpt.replace("ttxId=-1", "");
                myOpt += "&ttxId = " + this.getTtxId() + " & Sid=" + this.sessId;
            }
            else {
                myOpt += "&" + supOptions;
            }
        }
        return encodeURI("?" + myOpt);
    };
    Server.prototype.loadCurrentAppId = function (appDomain) {
        for (var i = 0; i < this.appList.apps.length; i++) {
            if (this.appList.apps[i].domain === appDomain) {
                this.currentAppId = i;
            }
        }
        if (this.currentAppId === -1) {
            throw new Error("domain token not loaded");
        }
        return;
    };
    Server.prototype.processUseResponse = function (useData) {
        return __awaiter(this, void 0, void 0, function () {
            var currentAdminIdx, j, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.myCurrentInstance === undefined) {
                            throw new Error("no instance loaded");
                        }
                        this.loginDataCurrentApp = useData;
                        currentAdminIdx = this.appList.apps[this.currentAppId].adminIdx;
                        for (j = this.appList.apps.length - 1; j >= 0; j--) {
                            if (this.appList.apps[j].adminIdx === currentAdminIdx) {
                                this.currentAdminId = j;
                                j = -1;
                            }
                        }
                        if (this.currentAdminId === -1) {
                            throw new Error("admin token not found");
                        }
                        this.currentMasterId = this.appList.apps.length - 1;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 4, 5]);
                        if (!(this.myLocalServiceInfo.flAdminUrl !== this.appList.apps[this.currentAdminId].url)) return [3, 3];
                        _a = this.myLocalServiceInfo;
                        return [4, this.httpFormatSecurePost(3, 110, "/api2/", -1, -1, {}, "")];
                    case 2:
                        _a.svcInfo = _b.sent();
                        this.myLocalServiceInfo.flAdminUrl = this.appList.apps[this.currentAdminId].url;
                        _b.label = 3;
                    case 3: return [3, 5];
                    case 4:
                        this.setPollingFreq(this.pollingFrequencyInitial);
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    Server.prototype.freeAllData = function () {
        this.myCurrentInstance = undefined;
        this.currentHostName = "";
        this.instancesList = [];
        this.appList.apps = [];
        this.freeCxion();
    };
    Server.prototype.freeCxion = function (bEraseLogin) {
        if (bEraseLogin === void 0) { bEraseLogin = false; }
        this.setPollingFreq(-1);
        this.myLocalServiceInfo = {
            flAdminUrl: "xyz",
            svcInfo: [],
        };
        this.currentUI = -1;
        this.currentAppId = -1;
        this.currentAdminId = -1;
        this.currentMasterId = -1;
        this.ttxId = 0;
        this.ttxIdDone = [];
        this.sessId = 0;
        this.notify({
            dbName: "logout", ttxId: -1, type: "flClient",
        });
        if (bEraseLogin) {
            if (this.appList !== undefined && this.appList.apps.length > 2) {
                this.appList.apps.splice(0, this.appList.apps.length - 2);
            }
        }
    };
    Server.prototype.removeJKeys = function (result, dataSet) {
        var _this = this;
        dataSet.forEach(function (aDSDoc) {
            var myDoc = {};
            var aDSDocOK = aDSDoc.j === undefined ? aDSDoc : aDSDoc.j;
            Object.keys(aDSDocOK).forEach(function (key) {
                if (key.startsWith("d")) {
                    if (aDSDocOK[key] instanceof Array) {
                        myDoc[key] = [];
                        _this.removeJKeys(myDoc[key], aDSDocOK[key]);
                    }
                    else {
                        myDoc[key] = aDSDocOK[key];
                    }
                }
                else {
                    myDoc[key] = aDSDocOK[key];
                }
            });
            result.push(myDoc);
        });
    };
    Server.prototype.snooze = function (ms) {
        return new Promise(function (commit) { return setTimeout(commit, ms); });
    };
    Server.prototype.waitAndRun = function (f) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.snooze(200)];
                    case 1:
                        _a.sent();
                        return [2, f];
                }
            });
        });
    };
    Server.prototype.httpFormatSecurePost = function (srvType, api, urlSuffix, eCN, id, dataIn, strOptions, params) {
        if (id === void 0) { id = -1; }
        if (dataIn === void 0) { dataIn = {}; }
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var dataToSend;
            return __generator(this, function (_a) {
                if (this.myCurrentInstance === undefined) {
                    throw new Error("no instance selected");
                }
                dataToSend = {
                    api: api,
                    dataIn: dataIn,
                    dbName: (api === 1 || api === 5) ? "flmain" : this.getDBName(srvType),
                    eCN: eCN,
                    id: id,
                    params: params,
                    strOptions: strOptions,
                    sync: this.getTtxId(),
                    trace: this.getTrace(),
                    version: 3,
                };
                return [2, this.httpPostLowLevel(this.getServerUrl(srvType) + urlSuffix, (api < 10) ? "" : this.getToken(srvType), dataToSend)];
            });
        });
    };
    Server.prototype.getFilePrefixUrl = function () {
        if (this.instanceProviderUrl.length < 5) {
            throw new Error("please load instances fist");
        }
        var idx = this.getIdxInAppList(1);
        return this.appList.apps[idx].fileServerUrlPrefix;
    };
    Server.prototype.getServerUrl = function (srvType) {
        if (srvType === void 0) { srvType = 1; }
        if (srvType === 2) {
            if (this.instanceProviderUrl.length < 5) {
                throw new Error("please load instances fist");
            }
            return this.instanceProviderUrl;
        }
        if (srvType === 4) {
            if (this.currentAppId === -1) {
                throw new Error("please log first");
            }
            return this.appList.apps[this.currentAppId].fileServerUrl;
        }
        var idx = this.getIdxInAppList(srvType);
        return this.appList.apps[idx].url;
    };
    Server.prototype.getIdxInAppList = function (srvType) {
        if (srvType === void 0) { srvType = 1; }
        var tkIdx = -1;
        switch (srvType) {
            case 2:
                if (this.currentMasterId === -1) {
                    throw new Error("please log first before to use master");
                }
                tkIdx = this.currentMasterId;
                break;
            case 1:
                if (this.currentAppId === -1) {
                    throw new Error("no application in use");
                }
                tkIdx = this.currentAppId;
                break;
            case 3:
                if (this.currentAdminId === -1) {
                    throw new Error("please log first");
                }
                tkIdx = this.currentAdminId;
                break;
            case 4:
                throw new Error("getIdxInAppList called for fileServer");
            default:
                var err = new Error("Invalid server type in getDBName");
                console.error(err.stack || err);
                throw err;
        }
        return tkIdx;
    };
    Server.prototype.getToken = function (srvType) {
        var tkIdx = this.getIdxInAppList(srvType);
        return this.appList.apps[tkIdx].token;
    };
    Server.prototype.httpPostLowLevel = function (url, token, dataToSent, bDisplayError) {
        var _this = this;
        if (bDisplayError === void 0) { bDisplayError = true; }
        return new Promise(function (commit, reject) {
            var bRunRemoveJKeys = typeof (dataToSent.strOptions) === "string" && dataToSent.strOptions.indexOf("rel=") > -1;
            var myApi = dataToSent.api;
            var timeSent = new Date().getTime();
            _this.setPollingFreq(-1);
            var ttxIdOut = _this.ttxId;
            var bInUserDB = dataToSent.dbName.indexOf("flmain") === -1;
            _this.srvDriver
                .Post(url, token, dataToSent, bDisplayError)
                .then(function (dataOut) { return __awaiter(_this, void 0, void 0, function () {
                var newResult;
                var _this = this;
                return __generator(this, function (_a) {
                    try {
                        if (dataOut === undefined ||
                            dataOut.status === undefined) {
                            console.error("flClient: protocol error - report to srv Dev: " + JSON.stringify(dataOut));
                            return [2, reject("protocol error")];
                        }
                        if ((this.getTrace() & 32768) === 32768) {
                            console.error("time to call: " + (new Date().getTime() - timeSent) + "ms, srv: " + dataOut.srvTime);
                        }
                        if (dataOut.status === 0) {
                            return [2, reject(dataOut.message)];
                        }
                        if (dataOut.sync < ttxIdOut) {
                            console.error("ttxId: " + ttxIdOut + " / " + dataOut.sync + " " + url);
                        }
                        if (myApi === 19) {
                            this.ttxId = dataOut.sync;
                        }
                        else {
                            if (!bInUserDB) {
                                dataOut.sync = this.ttxId;
                                if (this.ttxIdDone.indexOf(dataOut.sync) > -1) {
                                    this.ttxIdDone.splice(this.ttxIdDone.indexOf(dataOut.sync), 1);
                                }
                                dataOut.notifs.forEach(function (aNotif) {
                                    if (aNotif.dbName.indexOf("flmain") === -1) {
                                        aNotif.ttxId = _this.ttxId;
                                    }
                                });
                            }
                        }
                        this.notify(dataOut.notifs);
                        this.setPollingFreq(0);
                        if (bRunRemoveJKeys) {
                            newResult = [];
                            this.removeJKeys(newResult, dataOut.dataOut);
                            return [2, commit(newResult)];
                        }
                        return [2, commit(dataOut.dataOut)];
                    }
                    catch (errTry) {
                        this.setPollingFreq(0);
                        console.error("flClient: exception: " + errTry.stack);
                        return [2, reject(errTry)];
                    }
                    return [2];
                });
            }); }).catch(function (err) {
                _this.setPollingFreq(0);
                return reject(err);
            });
        });
    };
    Server.prototype.firstPromiseResolve = function (array) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!array || !array.length) {
                return reject(new Error("array passed to firstPromiseResolve() cannot be empty"));
            }
            var errors = new Array(array.length);
            var errorCntr = 0;
            _this.masterIdx = -1;
            array.forEach(function (p, index) {
                var myIdx = index;
                Promise.resolve(p).then(function (val) {
                    _this.masterIdx = myIdx;
                    resolve(val);
                }, function (err) {
                    errors[index] = err;
                    ++errorCntr;
                    if (errorCntr === array.length) {
                        reject(errors);
                    }
                });
            });
        });
    };
    return Server;
}());
exports.default = Server.getInstance();
